// ==================================================================================
// Digital Approval System (DAS) - Dashboard Endpoints
// ==================================================================================
// API endpoint definitions for dashboard statistics
// ==================================================================================

import { buildEndpoint } from '../base.endpoints';

const BASE_PATH = '/das/requests/dashboard';

/**
 * Dashboard endpoints
 */
export const dashboardEndpoints = {
  /**
   * Get dashboard summary statistics
   * GET /das/requests/dashboard/summary
   */
  getSummary: () => buildEndpoint(`${BASE_PATH}/summary`),

  /**
   * Get request counts by status
   * GET /das/requests/dashboard/status-summary
   */
  getStatusSummary: () => buildEndpoint(`${BASE_PATH}/status-summary`),

  /**
   * Get request counts by type
   * GET /das/requests/dashboard/type-summary
   */
  getTypeSummary: () => buildEndpoint(`${BASE_PATH}/type-summary`),

  /**
   * Get approval performance metrics
   * GET /das/requests/dashboard/approval-metrics
   */
  getApprovalMetrics: () => buildEndpoint(`${BASE_PATH}/approval-metrics`),

  /**
   * Get current user's work summary
   * GET /das/requests/dashboard/my-work
   */
  getMyWorkSummary: () => buildEndpoint(`${BASE_PATH}/my-work`),

  /**
   * Get recent activity across the system
   * GET /das/requests/dashboard/recent-activity
   */
  getRecentActivity: (topN?: number) => {
    const url = buildEndpoint(`${BASE_PATH}/recent-activity`);
    return topN ? `${url}?topN=${topN}` : url;
  },
} as const;
